// Ignore naming convention from the entire file from eslint
/* eslint @typescript-eslint/naming-convention: "off" */
import {
	DesktopEntityType,
	DesktopEntityTypeWithSystems,
	DesktopJobEntityType,
	DesktopSystemEntityType,
	LocationEntityType,
	LocationEntityTypeInsert,
	PrinterConfigEntityType,
	PrinterConfigEntityTypeInsert,
} from "@/lib/supabase/supabaseTypes";

export interface PrintJobItem {
	id: number;
	created_at: string;
	type: number;
	data: any;
	desktop_system_id: number | null;
	desktop_id: string;
	status: string;
	response_status: number | null;
	response_message: string | null;
	processed_at: string | null;
	printer_name: string;
	desktop_name: string;
}

export interface State {
	desktopsWithSystems: DesktopEntityTypeWithSystems[];
	selectedDesktopSystem: DesktopSystemWithJobs | null;
	desktopRequests: (DesktopJobEntityType & {
		desktop_systems: DesktopSystemEntityType & {
			desktops: DesktopEntityType;
		};
	})[];
	locations: LocationEntityType[];
	printerConfigs: PrinterConfigEntityType[];
	printJobs: PrintJobItem[];
}

export type DesktopSystemWithJobs = DesktopSystemEntityType & {
	desktop_jobs: DesktopJobEntityType[];
};

export const ORG_SETTINGS_KEY = "_org_settings";

export type PrintMode = "browser" | "desktop";

export const DOCUMENT_TYPES = [
	{ value: "default", label: "Standard (Fallback)", autoPrint: true },
	{ value: "kv", label: "Kostenvoranschlag", autoPrint: true },
	{ value: "ls", label: "Lieferschein", autoPrint: true },
	{ value: "rg", label: "Rechnung", autoPrint: true },
	{ value: "rg_doppel", label: "Rechnungsdoppel", autoPrint: true },
	{
		value: "zahlungserinnerung",
		label: "Zahlungserinnerung",
		autoPrint: true,
	},
	{ value: "mahnung_1", label: "Erste Mahnung", autoPrint: true },
	{ value: "mahnung_2", label: "Folgemahnung", autoPrint: true },
	{ value: "letzte_mahnung", label: "Letzte Mahnung", autoPrint: true },
	{ value: "bar", label: "Barzahlungsquittung", autoPrint: true },
	{ value: "karte", label: "Kartenzahlungsquittung", autoPrint: true },
	{ value: "akonto", label: "Akontorechnung", autoPrint: true },
	{ value: "gs", label: "Gutschrift", autoPrint: true },
	{ value: "auftragsblatt", label: "Auftragsblatt", autoPrint: true },
	{ value: "srg", label: "Sammelrechnung", autoPrint: true },
	{ value: "etik_auftrag", label: "Auftragsetikett", autoPrint: true },
] as const;

export enum DesktopSystemRequestTypes {
	NoRequest = 0,
	PrinterConfig = 1,
	PrintDocument = 2,
	PrintLabels = 3,
	ScannerConfig = 4,
	ScanDocument = 5,
}

export interface PrinterTray {
	id: number;
	name: string;
}

export interface PrinterPaperSize {
	name: string;
	width: number;
	height: number;
}

export interface PrinterCapabilities {
	trays: PrinterTray[];
	paperSizes: PrinterPaperSize[];
	supportsDuplex: boolean;
	supportsColor: boolean;
}
